import { ConfigProvider } from 'antd';
import 'antd/dist/reset.css';
import { Toaster } from 'react-hot-toast';
import { Provider } from 'react-redux';
import { BrowserRouter, useRoutes } from 'react-router-dom';

import store from './store';
import { routes } from './routes';

// Create a separate component for routes that will be inside BrowserRouter
const AppRoutes = () => {
    const routing = useRoutes(routes);
    return routing;
};

const App = () => {
    return (
        <Provider store={store}>
            <ConfigProvider>
                <BrowserRouter>
                    <AppRoutes />
                </BrowserRouter>
                <Toaster position="top-right" reverseOrder={false} />
            </ConfigProvider>
        </Provider>
    );
};

export default App;
